import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { APP_STORE_URL } from '../constants';

const Downloads = () => {
    const { getFullTranslation } = useLanguage();
    const downloads = getFullTranslation('downloads');

    return (
        <div id="download" className="bg-gray-50 py-24 scroll-mt-24">
            <div className="max-w-7xl mx-auto px-6">
                <h2 className="text-4xl font-bold text-center text-gray-900 mb-16">{downloads.title}</h2>

                {/* Mobile Apps */}
                <div className="max-w-md mx-auto">
                    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
                        <h3 className="text-xl font-bold text-gray-900 mb-6">{downloads.mobileApp}</h3>
                        <div className="space-y-4">
                            {/* iOS - App Store */}
                            <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" className="flex items-center p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition cursor-pointer">
                                <div className="w-10 h-10 bg-blue-500 rounded-lg flex items-center justify-center mr-4 shadow-md">
                                    <svg className="w-6 h-6 text-white" viewBox="0 0 384 512" fill="currentColor"><path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" /></svg>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-gray-900">App Store</h4>
                                    <span className="text-xs text-gray-500">{downloads.ios}</span>
                                </div>
                            </a>

                            {/* Android Play - Coming Soon */}
                            <div className="flex items-center p-4 bg-gray-50 rounded-xl opacity-60 cursor-not-allowed">
                                <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center mr-4 shadow-sm border border-gray-100">
                                    <span className="text-orange-500 font-bold text-xl">▶</span>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-gray-900">Google Play</h4>
                                    <span className="text-xs text-gray-500">{downloads.android} - 正在开发中</span>
                                </div>
                            </div>

                            {/* APK - Coming Soon */}
                            <div className="flex items-center p-4 bg-gray-50 rounded-xl opacity-60 cursor-not-allowed">
                                <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center mr-4 shadow-md text-white">
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                                </div>
                                <div>
                                    <h4 className="font-semibold text-gray-900">{downloads.directDownload}</h4>
                                    <span className="text-xs text-gray-500">Android - 正在开发中</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Downloads;
